import { getPageTitle, PageSEO } from '@/components/SEO';
import siteMetadata from '@/data/siteMetadata';
import { ReactComponent as FFLogo } from '@/public/static/images/ff_stacked_30.svg';
import { ReactComponent as GoogleLogo } from '@/public/static/images/Google_2015_logo.svg';
import { ReactComponent as NuroLogo } from '@/public/static/images/nuro_logo_dark.svg';

export default function About() {
  return (
    <div className="m-auto flex w-full max-w-4xl flex-col items-center">
      <PageSEO title={getPageTitle('About')} description={siteMetadata.description} />
      <h1 className="mt-4 mb-24 text-center text-3xl font-bold text-gray-900 dark:text-gray-100">
        About Us
      </h1>
      <h2 className="text-center text-2xl leading-7 text-gray-900 dark:text-gray-100">
        Built by leaders from companies at the cutting edge of deep learning.
      </h2>
      <div className="my-8 grid h-52 w-full grid-cols-1 gap-8 sm:h-32 sm:grid-cols-3 sm:gap-16 md:gap-24">
        <div className="col-span-1">
          <div className="relative h-full w-full">
            <NuroLogo alt="nuro-logo" className="next-image" layout="fill" />
          </div>
        </div>
        <div className="col-span-1">
          <div className="relative h-full w-full">
            <GoogleLogo alt="google-logo" className="next-image" layout="fill" />
          </div>
        </div>
        <div className="col-span-1">
          <div className="relative h-full w-full">
            <img
              alt="meta-logo"
              className="next-image"
              layout="fill"
              src={require('../public/static/images/meta-logo.png')}
            />
          </div>
        </div>
      </div>
      <h2 className="mt-16 text-center text-2xl leading-7 text-gray-900 dark:text-gray-100">
        Backed by top investors and executives in enterprise software and AI.
      </h2>
      <div className="my-8 grid h-52 w-full grid-cols-1 gap-8 sm:h-32 sm:grid-cols-2 sm:gap-16 md:gap-24">
        <div className="col-span-1">
          <div className="relative h-full w-full">
            <a
              href="https://foundersfund.com"
              target="_blank"
              rel="noreferrer"
              title="Founders Fund"
            >
              <FFLogo alt="founders-fund-logo" className="next-image" layout="fill" />
            </a>
          </div>
        </div>
        <div className="col-span-1">
          <div className="relative h-full w-full">
            <a href="https://www.greenoaks.com" target="_blank" rel="noreferrer" title="Greenoaks">
              <img
                alt="greenoaks-logo"
                className="next-image"
                layout="fill"
                src={require('../public/static/images/greenoaks-logo.png')}
              />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
